module.exports = __webpack_public_path__ + "static/media/theagilemonkeys_logo.c33dc964.svg";